import {
  AgencyFinanceAccount,
  KontaflexFrontendRequestModel,
  Vermittlernummer,
} from '@ps20/bff-models';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App, getBgvg } from '@ps20-frontend/frontend-models';
import { call } from '@redux-saga/core/effects';
import { DoRequestResponse, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { PS20Logger } from '@ps20-frontend/logging';
import { ToolbarAction, ToolbarActions } from '../toolbar.actions';

export const URL_AGENCY_ACCOUNT_INFO = '/privatschutz/api/agencyAccountInfo';
export enum KONTAFLEX_TOOLBAR_REQUEST_EVENTS {
  KONTAFLEX_REQUEST_FOR_TOOLBAR_SUCCESSFUL = 'KONTAFLEX_REQUEST_FOR_TOOLBAR_SUCCESSFUL',
  KONTAFLEX_REQUEST_FOR_TOOLBAR_ERROR = 'KONTAFLEX_REQUEST_FOR_TOOLBAR_ERROR',
}

export function* watchKontaflex() {
  yield takeLatest(
    ToolbarActions.CALL_KONTAFLEX,
    safeSaga(doKontaflexAgencyAccountRequest, App.SHOP_TOOLBAR),
  );
  yield takeEvery(
    KONTAFLEX_TOOLBAR_REQUEST_EVENTS.KONTAFLEX_REQUEST_FOR_TOOLBAR_SUCCESSFUL,
    safeSaga(successCallbackForToolbar, App.SHOP_TOOLBAR),
  );
  yield takeEvery(
    KONTAFLEX_TOOLBAR_REQUEST_EVENTS.KONTAFLEX_REQUEST_FOR_TOOLBAR_ERROR,
    safeSaga(errorCallbackKontaflexForToolbar, App.SHOP_TOOLBAR),
  );
}

export function* doKontaflexAgencyAccountRequest(action: ToolbarAction<Vermittlernummer>) {
  const vermittlernummer: Vermittlernummer = action.payload;

  const kontaflexBody: KontaflexFrontendRequestModel = {
    bgvg: getBgvg(vermittlernummer.zweigniederlassung),
    sammelnummer: vermittlernummer.geschaeftsstelle + vermittlernummer.vertreternummer,
    kontaflexInputList: [],
  };
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().doRequest({
      appId: App.SHOP_TOOLBAR,
      url: URL_AGENCY_ACCOUNT_INFO,
      body: kontaflexBody,
      noCache: true,
      successEvent: KONTAFLEX_TOOLBAR_REQUEST_EVENTS.KONTAFLEX_REQUEST_FOR_TOOLBAR_SUCCESSFUL,
      errorEvent: KONTAFLEX_TOOLBAR_REQUEST_EVENTS.KONTAFLEX_REQUEST_FOR_TOOLBAR_ERROR,
    }),
  );
}

export function* successCallbackForToolbar(response: DoRequestResponse<AgencyFinanceAccount>) {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new ToolbarActions().kontaflexReceived(response.payload));
}

export function errorCallbackKontaflexForToolbar(errorAction: AnyAction) {
  PS20Logger.error(
    App.SHOP_TOOLBAR,
    'Agency Finance Account request failed.',
    errorAction.payload.toString(),
  );
}
